import { atom } from "recoil";

/**
 * Coordination gate between the welcome-series companion modal (Novu in-app,
 * sonder welcome-series-v1) and marketing takeovers. While a welcome modal is
 * pending or has shown this session, FirstLandTakeover promos are suppressed —
 * new users get onboarding before marketing, and modals never stack.
 */
export const WelcomeSeriesGate = atom({
  key: "WelcomeSeriesGate_v0.1",
  default: {
    active: false,
  },
});
